import { useParams } from 'react-router-dom';

export function useSummarizationId() {
  const { summarizationId } = useParams<{ summarizationId?: string }>();

  return summarizationId;
}
